import React from 'react';
export const LegendLinkedEventsIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={24}
    height={18}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="9" r="9" fill="#147AF3" />
    <path
      d="M9.30309 14V12.7628L12.5854 9.5451C12.8993 9.2281 13.1609 8.9465 13.3702 8.70028C13.5795 8.45407 13.7364 8.21555 13.8411 7.98473C13.9457 7.75391 13.998 7.50769 13.998 7.24609C13.998 6.94756 13.9303 6.69212 13.7949 6.47976C13.6595 6.26432 13.4733 6.09813 13.2363 5.98118C12.9993 5.86423 12.7301 5.80575 12.4284 5.80575C12.1176 5.80575 11.8452 5.87038 11.6113 5.99964C11.3774 6.12583 11.1958 6.30587 11.0666 6.53977C10.9404 6.77367 10.8773 7.0522 10.8773 7.37536H9.24769C9.24769 6.77521 9.38465 6.25355 9.65856 5.81037C9.93247 5.36719 10.3095 5.02403 10.7896 4.78089C11.2728 4.53776 11.8268 4.41619 12.4515 4.41619C13.0855 4.41619 13.6426 4.53468 14.1227 4.77166C14.6028 5.00864 14.9752 5.33333 15.2399 5.74574C15.5076 6.15814 15.6415 6.62902 15.6415 7.15838C15.6415 7.51231 15.5738 7.86009 15.4384 8.2017C15.303 8.54332 15.0645 8.92187 14.7228 9.33736C14.3843 9.75284 13.9088 10.256 13.2963 10.8469L11.6667 12.5043V12.5689H15.7846V14H9.30309Z"
      fill="white"
    />
  </svg>
);
